<template>
  <div class="realize_wrap">
    <div
      class="realize_img"
      v-if="hiddenFiveNavOne1"
      :style="{ background: `url(${prodFive1.image}) 0 0 no-repeat`, backgroundSize: 'cover' }"
    >
      <div class="img_tit">{{ prodFive1.title }}</div>
    </div>
    <div class="realize_nav_wrap">
      <el-row class="realize_nav" type="flex" justify="center">
        <el-col v-for="(tab, index) in tabList" :key="index" class="realize_item"
          :class="tabSelectIndex === index ? 'active' : ''" :span="2" :xs="6"
          @click.native="changeTabIndex(index, tab.routePath)">
          <div class="nav_top">{{ tab.title }}</div>
          <div class="nav_bottom" :style="tabSelectIndex === index ? '' : 'background:#fff'"></div>
        </el-col>
      </el-row>
    </div>
    <div class="show_box_index" v-if="tabSelectIndex === 0">
      <div
        class="product_shows_wrap"
        v-if="hiddenFiveNavOne3"
        :style="{ background: `url(${prodFive3.image}) 0 0 no-repeat`, backgroundSize: 'cover' }"
      >
        <div class="production_title_wrap">
          <div class="production_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="production_title">{{ prodFive3.title }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="table_wrap hidden-xs-only">
          <el-form label-position="left" label-width="70px" class="table_form">
            <el-form-item :label="item.title + '：'" class="table_form_item" v-for="(item, index) in prodFive3Children"
              :key="index">
              {{ item.subTitle }}
            </el-form-item>
          </el-form>
        </div>
        <div class="table_wrap_mobile hidden-sm-and-up">
          <div class="table_form">
            <div class="table_form_item" v-for="(item, index) in prodFive3Children" :key="index">
              <span>{{ item.title }}:</span> {{ item.subTitle }}
            </div>
          </div>
        </div>
      </div>

      <template v-if="hiddenFiveNavOne4">
        <div class="production_title_wrap">
          <div class="production_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="production_title">{{ prodFive4.title }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="advantage_out_wrap">
          <el-row class="advantage_wrap">
            <el-col class="advantage_item" v-for="(item, index) in prodFive4Children" :key="index" :span="7" :xs="11"
              :style="{ background: `url(${item.Image}) 90% 10% no-repeat`, backgroundSize: '20%' }">
              <div class="item_top">
                <div class="icon hidden-xs-only"><i :class="item.icon"></i></div>
                <div class="tit">{{ item.Title }}</div>
              </div>
              <ul class="item_desc" v-for="(desc, index2) in item.SubTitle" :key="index2">
                <li>{{ desc }}</li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </template>

      <template v-if="hiddenFiveNavOne5">
        <div class="production_title_wrap">
          <div class="production_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="production_title">{{ prodFive5.title }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <PersonCard :personList="prodFive5Children" />
      </template>

      <template v-if="hiddenFiveNavOne6">
        <div class="production_title_wrap">
          <div class="production_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center" style="width: 50%">
              <div class="production_title">{{ prodFive6.title }}</div>
              <div class="production_desc">
                {{ prodFive6.subtitle }}
              </div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="china_map">
          <img :src="item.image" v-for="(item, index) in prodFive6Children" :key="index" alt="" />
        </div>
      </template>
    </div>
    <div class="show_box_index" v-if="tabSelectIndex === 1">
      <div class="four_wrap" v-if="hiddenFiveNavTwo1">
        <el-row type="flex" justify="center" class="out_card" :gutter="10">
          <el-col :span="7" v-for="(item, index) in prodFive7Children" :key="index" class="card_item">
            <el-card :body-style="{ padding: '0px' }" class="card_content">
              <div style="padding: 14px">
                <img :src="item.image" class="image" />
                <div style="margin-top: 20px; font-size: 1rem; font-weight: bold">
                  {{ item.title }}
                </div>
                <div class="bottom clearfix">
                  <el-button type="text" class="button" style="font-size:0.7rem;">{{
                    item.subTitle
                  }}</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <template v-if="hiddenFiveNavTwo2">
        <div class="production_title_wrap">
          <div class="production_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="production_title">{{ prodFive8.title }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="four_card_spa hidden-xs-only">
          <el-row type="flex" justify="space-between" class="out_card">
            <el-col :span="7" class="card_item" v-for="(item, index) in prodFive8Children" :key="index">
              <h1>{{ item.Title }}</h1>
              <img src="../../assets/img/position.png" alt="" />
              <div class="card_bg"></div>
              <p style="font-size: 12px;">{{ item.SubTitle && item.SubTitle[0] }}</p>
              <h1>{{ item.SubTitle && item.SubTitle[1] }}</h1>
            </el-col>
          </el-row>
        </div>
        <div class="real_wrap">
          <ReailzeCard :reailzeList="reailzeList" class="hidden-sm-and-up" />
        </div>
      </template>
    </div>
    <CallMe />
    <MobileCallme></MobileCallme>
  </div>
</template>

<script>
import PersonCard from './PersonCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import ReailzeCard from './ReailzeCard.vue'
import TimeLineYunYi from './TimeLineYunYi.vue'
import TimeLineMobile from './TimeLineMobile.vue'
import { leftLikeDict } from '../../api/system'
import Constant from '../../utils/Constant'
import { findDictHidden, findMainProp, transDictDataNotTypeMore, transDictDataTotal } from '../../utils'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      hiddenFiveNavOne1: true,
      hiddenFiveNavOne3: true,
      hiddenFiveNavOne4: true,
      hiddenFiveNavOne5: true,
      hiddenFiveNavOne6: true,
      hiddenFiveNavTwo1: true,
      hiddenFiveNavTwo2: true,
      tabList: [
      ],
      tabSelectIndex: 0,
      reailzeList: [
      ],
      prodFive1: {},
      prodFive3: {},
      prodFive3Children: [],
      prodFive4: {},
      prodFive4Children: [],
      prodFive5: {},
      prodFive5Children: [],
      prodFive6: {},
      prodFive6Children: [],
      prodFive7Children: [],
      prodFive8: [],
      prodFive8Children: []
    }
  },
  computed: {
    ...mapGetters(['getMenuList']),
    menuList() {
      return this.getMenuList
    }
  },
  methods: {
    changeTabIndex(index, path) {
      this.tabSelectIndex = index
      this.$router.push(path)
    },
    processMenuList() {
      const fivenavMenu = this.menuList.find(v => v.routePath === '/fivenav')
      if (fivenavMenu && fivenavMenu.children) {
        this.tabList = fivenavMenu.children.reduce((pre, cur) => {
          pre.push({
            title: cur.routeName,
            routePath: cur.routePath
          })
          return pre
        }, [])
      }
    },
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.FIVENAV_ONE1);
      if (res.data) {
        this.hiddenFiveNavOne1 = findDictHidden(Constant.FIVENAV_ONE1, res.data.data)
        this.prodFive1 = findMainProp(res.data.data, Constant.FIVENAV_ONE1)
      }
      const res3 = await leftLikeDict(Constant.FIVENAV_ONE3);
      if (res3.data) {
        this.hiddenFiveNavOne3 = findDictHidden(Constant.FIVENAV_ONE3, res3.data.data)
        this.prodFive3 = findMainProp(res3.data.data, Constant.FIVENAV_ONE3)
        this.prodFive3Children = transDictDataNotTypeMore(res3.data.data.find(v => v.dictKey === 'fivenav_one3Title')?.children || [], 'fivenav_one3Content')
      }
      const res4 = await leftLikeDict(Constant.FIVENAV_ONE4);
      if (res4.data) {
        this.hiddenFiveNavOne4 = findDictHidden(Constant.FIVENAV_ONE4, res4.data.data)
        this.prodFive4 = findMainProp(res4.data.data, Constant.FIVENAV_ONE4)
        this.prodFive4Children = transDictDataTotal(res4.data.data.find(v => v.dictKey === 'fivenav_one4Title')?.children || [], 'fivenav_one4Content')
      }
      const res5 = await leftLikeDict(Constant.FIVENAV_ONE5);
      if (res5.data) {
        this.hiddenFiveNavOne5 = findDictHidden(Constant.FIVENAV_ONE5, res5.data.data)
        this.prodFive5 = findMainProp(res5.data.data, Constant.FIVENAV_ONE5)
        this.prodFive5Children = transDictDataTotal(res5.data.data.find(v => v.dictKey === 'fivenav_one5Title')?.children || [], 'fivenav_one5Content') || []
      }
      const res6 = await leftLikeDict(Constant.FIVENAV_ONE6);
      if (res6.data) {
        this.hiddenFiveNavOne6 = findDictHidden(Constant.FIVENAV_ONE6, res6.data.data)
        this.prodFive6 = findMainProp(res6.data.data, Constant.FIVENAV_ONE6)
        this.prodFive6Children = transDictDataNotTypeMore(res6.data.data.find(v => v.dictKey === 'fivenav_one6Title')?.children || [], 'fivenav_one6Content')
      }
      const res7 = await leftLikeDict(Constant.FIVENAV_TWO1);
      if (res7.data) {
        this.hiddenFiveNavTwo1 = findDictHidden(Constant.FIVENAV_TWO1, res7.data.data)
        this.prodFive7Children = transDictDataNotTypeMore(res7.data.data.find(v => v.dictKey === 'fivenav_two1')?.children || [], 'fivenav_two1Content')
      }
      const res8 = await leftLikeDict(Constant.FIVENAV_TWO2);
      if (res8.data) {
        this.hiddenFiveNavTwo2 = findDictHidden(Constant.FIVENAV_TWO2, res8.data.data)
        this.prodFive8 = findMainProp(res8.data.data, Constant.FIVENAV_TWO2)
        this.prodFive8Children = transDictDataTotal(res8.data.data.find(v => v.dictKey === 'fivenav_two2Title')?.children || [], 'fivenav_two2Content')
        this.reailzeList = this.prodFive8Children.reduce((pre, cur) => {
          pre.push({ title: cur.Title, subTitle: cur.SubTitle })
          return pre
        }, [])
      }
    },
  },
  components: {
    PersonCard,
    CallMe,
    MobileCallme,
    ReailzeCard,
    TimeLineYunYi,
    TimeLineMobile
  },
  created() {
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  mounted() {
    this.leftLikeDictFunc()
    // 如果 menuList 已有数据，直接执行
    if (this.menuList && this.menuList.length > 0) {
      this.processMenuList()
    }
  },
  watch: {
    $route() {
      this.tabSelectIndex =
        this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
    // 监听 menuList 变化
    menuList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.processMenuList()
        }
      },
      immediate: true
    }
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  .realize_img {
    width: 100%;
    height: 600px;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    /* background: url('../../assets/img/aboutbg.054cc8b.jpg') 0 0 no-repeat; */
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;

      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .realize_nav_wrap {
    width: 100%;
    height: 60px;

    @media screen and (max-width: 768px) {
      height: 50px;
    }

    .realize_nav {
      height: 100%;
      display: flex;
      align-items: center;

      .active {
        font-weight: bold;
        color: #000;
      }

      .realize_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .nav_top {
          font-size: 18px;
          cursor: pointer;

          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }

        .nav_bottom {
          width: 30%;
          height: 4px;
          margin-top: 10px;
          background: #2091d3;
        }
      }
    }
  }

  .product_shows_wrap {
    width: 100%;
    padding: 10px 0 50px 0;
    margin-top: -7px;
    box-sizing: border-box;
    height: 700px;
    position: relative;

    @media screen and (max-width: 768px) {
      background: #f4f9fc;
      height: auto;
    }

    .table_wrap {
      position: absolute;
      top: 23%;
      left: 20%;
      width: 400px;

      .table_form {
        .table_form_item {
          font-weight: bold;
        }
      }
    }

    .table_wrap_mobile {
      padding: 1rem;

      p {
        font-size: 0.9rem;
      }

      .table_form {
        .table_form_item {
          font-weight: bold;
          margin-top: 1rem;
          font-size: 0.85rem;

          span {
            color: #000;
            font-size: 0.9rem;
            padding-right: 30px;
          }
        }
      }
    }
  }

  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;

    .advantage_wrap {
      width: 70%;
      display: flex;
      margin-top: 70px;
      justify-content: center;
      flex-wrap: wrap;

      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .advantage_item {
        height: auto;
        padding: 30px 20px 60px 20px;
        margin-right: 10px;

        margin: 15px;
        box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);

        @media screen and (max-width: 768px) {
          margin: 0;
          padding: 0 15px;
          margin-top: 3px;
          height: 140px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          height: 200px;
        }

        .item_top {
          display: flex;
          align-items: center;

          @media screen and (max-width: 768px) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          }

          .icon {
            i {
              color: #2091d3;
              font-size: 26px;
              padding-right: 10px;

              @media screen and (max-width: 768px) {
                font-size: 2rem;
                margin-bottom: 10px;
              }
            }
          }

          .tit {
            width: 100%;
            color: #1c1c1c;
            font-size: 28px;
            font-weight: bold;

            @media screen and (max-width: 768px) {
              font-size: 1rem;
              text-align: left;
            }
          }
        }

        .item_desc {
          font-size: 20px;
          line-height: 20px;
          margin: 0;
          padding: 0;
          margin-top: 20px;
          color: #646464;
          list-style: none;

          li {
            line-height: 2rem;

            @media screen and (max-width: 768px) {
              line-height: 1rem;
              font-size: 12px;
            }

            &:first-child {
              margin-top: 30px;
            }
          }
        }
      }
    }
  }

  .china_map {
    width: 70%;
    margin: 50px auto;

    img {
      width: 100%;
    }
  }

  .timeline_wrap {
    width: 70%;
    margin: 0 auto;

    @media screen and (max-width: 768px) {
      width: 100%;
    }

    .timeline_card {
      h4 {
        font-size: 24px;

        @media screen and (max-width: 768px) {
          font-size: 18px;
        }
      }

      .timeline_time {
        font-size: 12PX;
      }

      img {
        width: 30%;
        margin-top: 20px;

        @media screen and (max-width: 768px) {
          width: 100%;
        }
      }
    }
  }

  .three_box {
    width: 70%;
    margin: 0 auto;
    height: 200px;
    text-align: center;
    background: url('../../assets/img/ryzz.bc140e4.jpg') 0 0 no-repeat;
    background-size: cover;

    @media screen and (max-width: 768px) {
      width: 100%;
    }

    h1 {
      font-size: 40px;
      line-height: 200px;
      color: #fff;
    }
  }

  .three_box_card {
    width: 70%;
    margin: 30px auto;

    @media screen and (max-width: 768px) {
      width: 100%;
    }

    .out_card {
      flex-wrap: wrap;

      .card_item {
        @media screen and (max-width: 768px) {
          margin-top: 10px;
        }

        &:nth-child(n + 4) {
          margin-top: 10px;
        }

        img {
          padding-top: 30px;
          width: 100%;
        }
      }
    }
  }

  .four_wrap {
    width: 70%;
    margin: 0 auto;
    background: url('../../assets/img/58.e28b1c0.png') 0 0 no-repeat;
    background-size: cover;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 768px) {
      width: 100%;
      height: 150px;
    }

    .out_card {
      width: 100%;
      flex-wrap: wrap;

      .card_item {
        &:nth-child(n + 4) {
          margin-top: 10px;
        }

        .card_content {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 100%;

          img {
            padding-top: 30px;
            width: 30%;

            @media screen and (max-width: 768px) {
              width: 50%;
            }
          }
        }
      }
    }
  }

  .four_card_spa {
    width: 70%;
    margin: 30px auto;

    .out_card {
      .card_item {
        h1 {
          font-size: 30px;
          margin-top: 10px;
        }

        img {
          margin-top: 30px;
          width: 5%;
        }

        p {
          font-size: 12px;
          margin-top: 10px;
        }

        .card_bg {
          width: 30px;
          height: 5px;
          background: #13519f;
        }
      }
    }
  }
}

.production_title_wrap {
  width: 100%;
  margin-top: 50px;

  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }

  .production_inner {
    display: flex;
    justify-content: center;

    .inner_left {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      @media screen and (max-width: 768px) {
        flex: 1;
      }

      img {
        width: 30%;
      }
    }

    .inner_center {
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 50px;

      @media screen and (max-width: 768px) {
        flex: 2.2;
      }

      .production_title {
        font-size: 40px;
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }

      .production_desc {
        font-size: 16px;
        color: #787878;
        margin-top: 10px;

        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }

    .inner_right {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      @media screen and (max-width: 768px) {
        flex: 1;
      }

      img {
        width: 30%;
      }
    }
  }
}
</style>